<template>
  <button
      type="button"
      class="assessment-mode-card"
      data-analytics-skip
      :class="{ 'assessment-mode-card--locked': locked }"
      :disabled="!option.enabled"
      @click="selectOption"
  >
    <span class="assessment-mode-card__top">
      <span
          class="assessment-mode-card__icon"
          :class="`assessment-mode-card__icon--${option.id}`"
          aria-hidden="true"
      >
        <v-icon
            class="assessment-mode-card__glyph"
            :class="`assessment-mode-card__glyph--${option.id}`"
        >
          {{ option.icon }}
        </v-icon>
      </span>

    </span>

    <span class="assessment-mode-card__content">
      <span class="assessment-mode-card__title">
        {{ $t(option.titleToken) }}
      </span>

      <span class="assessment-mode-card__description">
        {{ $t(option.descriptionToken) }}
      </span>
    </span>
    <v-icon v-if="locked" class="assessment-mode-card__lock">
      {{ lockIcon }}
    </v-icon>
    <v-icon v-else class="assessment-mode-card__chevron">
      {{ chevronIcon }}
    </v-icon>
  </button>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { mdiChevronLeft, mdiChevronRight, mdiLock } from '@mdi/js'

import type {
  AssessmentMode,
  AssessmentModeOption,
} from '../types/assessment-mode.types';

export default defineComponent({
  name: 'AssessmentModeCard',

  props: {
    option: {
      type: Object as PropType<AssessmentModeOption>,
      required: true,
    },

    selected: {
      type: Boolean,
      default: false,
    },

    locked: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({ lockIcon: mdiLock }),

  computed: {
    chevronIcon(): string {
      return this.$vuetify.rtl ? mdiChevronLeft : mdiChevronRight
    },
  },

  setup(props, { emit }) {

    const selectOption = (): void => {
      if (!props.option.enabled) {
        return;
      }

      if (props.locked) {
        emit('locked', props.option.id as AssessmentMode);
        return;
      }

      emit('select', props.option.id as AssessmentMode);
    };

    return {
      selectOption,
    };
  },
});
</script>
